import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const SettingsViewChunk = React.lazy(() =>
  import('../containers/SettingsView').then(({ SettingsView }) => ({
    default: SettingsView,
  }))
)

export const SettingsPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.settingsPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.settingsPageTitle),
        },
      ]}
    >
      <SettingsViewChunk />
    </Page>
  )
}
